import { Gem, ShoppingBag, UserRound } from "lucide-react";

const menuData: any = [
  // {
  //   label: "menu",
  //   isTitle: true,
  // },
  // {
  //   id: "dashboard",
  //   label: "Dashboards",
  //   link: "/#",
  //   icon: <MonitorDot />,
  //   subItems: [
  //     {
  //       id: "analyticsdashboard",
  //       label: "Analytics",
  //       link: "/dashboards-analytics",
  //       parentId: "dashboard",
  //     },
  //     {
  //       id: "ecommercedashboard",
  //       label: "Ecommerce",
  //       link: "/dashboard",
  //       parentId: "dashboard",
  //     },
  //     {
  //       id: "emaildashboard",
  //       label: "Email",
  //       link: "/dashboards-email",
  //       parentId: "dashboard",
  //     },
  //     {
  //       id: "hrdashboard",
  //       label: "HR",
  //       link: "/dashboards-hr",
  //       parentId: "dashboard",
  //     },
  //     {
  //       id: "socialdashboard",
  //       label: "Social",
  //       link: "/dashboards-social",
  //       parentId: "dashboard",
  //     },
  //   ],
  // },

  {
    label: "Diamonds",
    isTitle: true,
  },
  // {
  //   id: "chat",
  //   label: "Chat",
  //   icon: <MessageSquare />,
  //   link: "/apps-chat",
  //   parentId: 2,
  // },
  // {
  //   id: "email",
  //   label: "Email",
  //   icon: <Mail />,
  //   link: "/apps-mailbox",
  //   parentId: 2,
  // },
  // {
  //   id: "calendar",
  //   label: "Calendar",
  //   link: "/#",
  //   icon: <CalendarDays />,
  //   subItems: [
  //     {
  //       id: "default",
  //       label: "Default",
  //       link: "/apps-calendar",
  //       parentId: "calendar",
  //     },
  //     {
  //       id: "monthgrid",
  //       label: "Month Grid",
  //       link: "/apps-calendar-month-grid",
  //       parentId: "calendar",
  //     },
  //     {
  //       id: "multimonth",
  //       label: "Multi Month Stack",
  //       link: "/apps-calendar-multi-month-stack",
  //       parentId: "calendar",
  //     },
  //   ],
  // },
  {
    id: "ecommerce",
    label: "Ecommerce",
    link: "/#",
    icon: <ShoppingBag />,
    subItems: [
      {
        id: "product",
        label: "Products",
        parentId: "ecommerce",
        subItems: [
          {
            id: "listview",
            label: "List View",
            link: "/apps-ecommerce-product-list",
            parentId: "product",
          },
          {
            id: "gridview",
            label: "Grid View",
            link: "/apps-ecommerce-product-grid",
            parentId: "product",
          },
          {
            id: "overview",
            label: "Overview",
            link: "/apps-ecommerce-product-overview",
            parentId: "product",
          },
          {
            id: "addnew",
            label: "Add New",
            link: "/apps-ecommerce-product-create",
            parentId: "product",
          },
        ],
      },
      {
        id: "shoppingcart",
        label: "Shopping Cart",
        link: "/apps-ecommerce-cart",
        parentId: "ecommerce",
      },
      {
        id: "checkout",
        label: "Checkout",
        link: "/apps-ecommerce-checkout",
        parentId: "ecommerce",
      },
      {
        id: "order",
        label: "Orders",
        link: "/apps-ecommerce-orders",
        parentId: "ecommerce",
      },
      {
        id: "orderoverview",
        label: "Order Overview",
        link: "/apps-ecommerce-order-overview",
        parentId: "ecommerce",
      },
      {
        id: "sellers",
        label: "Sellers",
        link: "/apps-ecommerce-sellers",
        parentId: "ecommerce",
      },
    ],
  },
  {
    id: "diamond",
    label: "Diamond",
    link: "/#",
    icon: <Gem />,
    subItems: [
      {
        id: "diamonds",
        label: "Diamonds",
        link: "/diamonds",
        parentId: "diamond",
      },
      {
        id: "inventoried",
        label: "Inventories",
        link: "/inventories",
        parentId: "diamond",
      },
      {
        id: "orders",
        label: "Orders",
        link: "/diamond-orders",
        parentId: "diamond",
      },
      {
        id: "shapes",
        label: "Shapes",
        link: "/diamond-shapes",
        parentId: "diamond",
      },
      {
        id: "prices",
        label: "Prices",
        link: "/diamond-prices",
        parentId: "diamond",
      },
    ],
  },
  {
    id: "jewellery",
    label: "Jewellery",
    link: "/jewellery",
    icon: <ShoppingBag />,
    subItems: [
      {
        id: "products",
        label: "Products",
        link: "/jewellery",
        parentId: "jewellery",
      },
      {
        id: "addnew",
        label: "Add New",
        link: "/add-jewellery",
        parentId: "jewellery",
      },
      {
        id: "discount",
        label: "Discount",
        link: "/add-discount",
        parentId: "jewellery",
      },
      {
        id: "orders",
        label: "Orders",
        link: "/jewellery-orders",
        parentId: "jewellery",
      },
      {
        id: "generateOrder",
        label: "Assisted Orders",
        link: "/generate-order",
        parentId: "jewellery",
      },
      {
        id: "categories",
        label: "Categories",
        link: "/categories",
        parentId: "jewellery",
      },
      {
        id: "subcategories",
        label: "Sub Categories",
        link: "/sub-categories",
        parentId: "jewellery",
      },
      // {
      //   id: "styles",
      //   label: "Styles",
      //   link: "/styles",
      //   parentId: "jewellery",
      // },
      {
        id: "metals",
        label: "Metals",
        link: "/metals",
        parentId: "jewellery",
      },
      // {
      //   id: "createblog",
      //   label: "Create Blog",
      //   link: "/create-blog",
      //   parentId: "jewellery",
      // },
    ],
  },
  {
    id: "blog",
    label: "Blog",
    link: "/create-blog",
    // icon: <ShoppingBag />,
    subItems: [
      {
        id: "blogs",
        label: "Blogs",
        link: "/blogs",
        parentId: "blog",
      },
      {
        id: "createblog",
        label: "Create Blog",
        link: "/create-blog",
        parentId: "blog",
      },
    ],
  },
  {
    id: "rbac",
    label: "RBAC",
    link: "/rbac-table",
    // icon: <ShoppingBag />,
    subItems: [
      {
        id: "rbactable",
        label: "RBACTable",
        link: "/rbac-table",
        parentId: "rbac",
      },
    ],
  },
  // {
  //   id: "hr-management",
  //   label: "HR Management",
  //   icon: <CircuitBoard />,
  //   parentId: "hrmanagement",
  //   link: "/#",
  //   subItems: [
  //     {
  //       id: "employeelist",
  //       label: "Employee List",
  //       link: "/apps-hr-employee",
  //       parentId: "hrmanagement",
  //     },
  //     {
  //       id: "holiday",
  //       label: "Holidays",
  //       link: "/apps-hr-holidays",
  //       parentId: "hrmanagement",
  //     },
  //     {
  //       id: "leavesmanage",
  //       label: "Leaves Manage",
  //       parentId: "hrmanagement",
  //       subItems: [
  //         {
  //           id: "byemployee",
  //           label: "By Employee",
  //           link: "/apps-hr-leave-employee",
  //           parentId: "leavesmanage",
  //         },
  //         {
  //           id: "addleaveemployee",
  //           label: "Add Leave (Employee)",
  //           link: "/apps-hr-create-leave-employee",
  //           parentId: "leavesmanage",
  //         },
  //         {
  //           id: "byhr",
  //           label: "By HR",
  //           link: "/apps-hr-leave",
  //           parentId: "leavesmanage",
  //         },
  //         {
  //           id: "addleavehr",
  //           label: "Add Leave (HR)",
  //           link: "/apps-hr-create-leave",
  //           parentId: "leavesmanage",
  //         },
  //       ],
  //     },
  //     {
  //       id: "attendance",
  //       label: "Attendance",
  //       parentId: "hrmanagement",
  //       subItems: [
  //         {
  //           id: "attendancehr",
  //           label: "Attendance (HR)",
  //           link: "/apps-hr-attendance",
  //           parentId: "attendance",
  //         },
  //         {
  //           id: "mainattendance",
  //           label: "Main Attendance",
  //           link: "/apps-hr-attendance-main",
  //           parentId: "attendance",
  //         },
  //       ],
  //     },
  //     {
  //       id: "department",
  //       label: "Department",
  //       link: "/apps-hr-department",
  //       parentId: "hrmanagement",
  //     },
  //     {
  //       id: "sale",
  //       label: "Sales",
  //       parentId: "hrmanagement",
  //       subItems: [
  //         {
  //           id: "estimates",
  //           label: "Estimates",
  //           link: "/apps-hr-sales-estimates",
  //           parentId: "sale",
  //         },
  //         {
  //           id: "payments",
  //           label: "Payments",
  //           link: "/apps-hr-sales-payments",
  //           parentId: "sale",
  //         },
  //         {
  //           id: "expenses",
  //           label: "Expenses",
  //           link: "/apps-hr-sales-expenses",
  //           parentId: "sale",
  //         },
  //       ],
  //     },
  //     {
  //       id: "payroll",
  //       label: "Payroll",
  //       parentId: "hrmanagement",
  //       subItems: [
  //         {
  //           id: "employeesalary",
  //           label: "Employee Salary",
  //           link: "/apps-hr-payroll-employee-salary",
  //           parentId: "payroll",
  //         },
  //         {
  //           id: "payslip",
  //           label: "Payslip",
  //           link: "/apps-hr-payroll-payslip",
  //           parentId: "payroll",
  //         },
  //         {
  //           id: "createpayslip",
  //           label: "Create Payslip",
  //           link: "/apps-hr-payroll-create-payslip",
  //           parentId: "payroll",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   id: "notes",
  //   label: "Notes",
  //   icon: <ScrollText />,
  //   link: "/apps-notes",
  //   parentId: 2,
  // },
  // {
  //   id: "social",
  //   label: "Social",
  //   icon: <RadioTower />,
  //   subItems: [
  //     {
  //       id: "friends",
  //       label: "Friends",
  //       link: "/apps-social-friends",
  //       parentId: "social",
  //     },
  //     {
  //       id: "event",
  //       label: "Event",
  //       link: "/apps-social-event",
  //       parentId: "social",
  //     },
  //     {
  //       id: "watchvideo",
  //       label: "Watch Video",
  //       link: "/apps-social-video",
  //       parentId: "social",
  //     },
  //     {
  //       id: "marketplace",
  //       label: "Marketplace",
  //       link: "/apps-social-marketplace",
  //       parentId: "social",
  //     },
  //   ],
  // },
  // {
  //   id: "invoice",
  //   label: "Invoices",
  //   icon: <FileText />,
  //   parentId: 2,
  //   subItems: [
  //     {
  //       id: "invoicelistview",
  //       label: "Listview",
  //       link: "/apps-invoice-list",
  //       parentId: "invoice",
  //     },
  //     {
  //       id: "invoiceaddnew",
  //       label: "Add New",
  //       link: "/apps-invoice-add-new",
  //       parentId: "invoice",
  //     },
  //     {
  //       id: "invoiceoverview",
  //       label: "Overview",
  //       link: "/apps-invoice-overview",
  //       parentId: "invoice",
  //     },
  //   ],
  // },
  {
    id: "users",
    label: "Users",
    icon: <UserRound />,
    parentId: 2,
    subItems: [
      {
        id: "customers",
        label: "Customers",
        link: "/customers",
        parentId: "users",
      },
      {
        id: "suppliers",
        label: "Suppliers",
        link: "/suppliers",
        parentId: "users",
      },
      // {
      //   id: "userlistview",
      //   label: "List view",
      //   link: "/apps-users-list",
      //   parentId: "users",
      // },
      // {
      //   id: "usergridview",
      //   label: "Grid View",
      //   link: "/apps-users-grid",
      //   parentId: "users",
      // },
    ],
  },
  // {
  //   label: "Pages",
  //   isTitle: true,
  // },
  // {
  //   id: "authentication",
  //   label: "Authentication",
  //   icon: <Award />,
  //   parentId: 2,
  //   subItems: [
  //     {
  //       id: "login",
  //       label: "Login",
  //       parentId: "social",
  //       subItems: [
  //         {
  //           id: "basic",
  //           label: "Basic",
  //           link: "/auth-login-basic",
  //           parentId: "login",
  //         },
  //         {
  //           id: "cover",
  //           label: "Cover",
  //           link: "/auth-login-cover",
  //           parentId: "login",
  //         },
  //         {
  //           id: "boxed",
  //           label: "Boxed",
  //           link: "/auth-login-boxed",
  //           parentId: "login",
  //         },
  //         {
  //           id: "modern",
  //           label: "Modern",
  //           link: "/auth-login-modern",
  //           parentId: "login",
  //         },
  //       ],
  //     },
  //     {
  //       id: "register",
  //       label: "Register",
  //       parentId: "social",
  //       subItems: [
  //         {
  //           id: "registerbasic",
  //           label: "Basic",
  //           link: "/auth-register-basic",
  //           parentId: "register",
  //         },
  //         {
  //           id: "registercover",
  //           label: "Cover",
  //           link: "/auth-register-cover",
  //           parentId: "register",
  //         },
  //         {
  //           id: "registerboxed",
  //           label: "Boxed",
  //           link: "/auth-register-boxed",
  //           parentId: "register",
  //         },
  //         {
  //           id: "registermodern",
  //           label: "Modern",
  //           link: "/auth-register-modern",
  //           parentId: "register",
  //         },
  //       ],
  //     },
  //     {
  //       id: "verifyemail",
  //       label: "Verify Email",
  //       parentId: "social",
  //       subItems: [
  //         {
  //           id: "verifyemailbasic",
  //           label: "Basic",
  //           link: "/auth-verify-email-basic",
  //           parentId: "verifyemail",
  //         },
  //         {
  //           id: "verifyemailcover",
  //           label: "Cover",
  //           link: "/auth-verify-email-cover",
  //           parentId: "verifyemail",
  //         },
  //         {
  //           id: "verifyemailmodern",
  //           label: "Modern",
  //           link: "/auth-verify-email-modern",
  //           parentId: "verifyemail",
  //         },
  //       ],
  //     },
  //     {
  //       id: "twostep",
  //       label: "Two Steps",
  //       parentId: "social",
  //       subItems: [
  //         {
  //           id: "twostepbasic",
  //           label: "Basic",
  //           link: "/auth-two-steps-basic",
  //           parentId: "twostep",
  //         },
  //         {
  //           id: "twostepcover",
  //           label: "Cover",
  //           link: "/auth-two-steps-cover",
  //           parentId: "twostep",
  //         },
  //         {
  //           id: "twostepboxed",
  //           label: "Boxed",
  //           link: "/auth-two-steps-boxed",
  //           parentId: "twostep",
  //         },
  //         {
  //           id: "twostepmodern",
  //           label: "Modern",
  //           link: "/auth-two-steps-modern",
  //           parentId: "twostep",
  //         },
  //       ],
  //     },
  //     {
  //       id: "logout",
  //       label: "Logout",
  //       parentId: "social",
  //       subItems: [
  //         {
  //           id: "logoutbasic",
  //           label: "Basic",
  //           link: "/auth-logout-basic",
  //           parentId: "logout",
  //         },
  //         {
  //           id: "logoutcover",
  //           label: "Cover",
  //           link: "/auth-logout-cover",
  //           parentId: "logout",
  //         },
  //         {
  //           id: "logoutboxed",
  //           label: "Boxed",
  //           link: "/auth-logout-boxed",
  //           parentId: "logout",
  //         },
  //         {
  //           id: "logoutmodern",
  //           label: "Modern",
  //           link: "/auth-logout-modern",
  //           parentId: "logout",
  //         },
  //       ],
  //     },
  //     {
  //       id: "resetpw",
  //       label: "Reset Password",
  //       parentId: "social",
  //       subItems: [
  //         {
  //           id: "resetpwbasic",
  //           label: "Basic",
  //           link: "/auth-reset-password-basic",
  //           parentId: "resetpw",
  //         },
  //         {
  //           id: "resetpwcover",
  //           label: "Cover",
  //           link: "/auth-reset-password-cover",
  //           parentId: "resetpw",
  //         },
  //         {
  //           id: "resetpwboxed",
  //           label: "Boxed",
  //           link: "/auth-reset-password-boxed",
  //           parentId: "resetpw",
  //         },
  //         {
  //           id: "resetpwmodern",
  //           label: "Modern",
  //           link: "/auth-reset-password-modern",
  //           parentId: "resetpw",
  //         },
  //       ],
  //     },
  //     {
  //       id: "createpw",
  //       label: "Create Password",
  //       parentId: "social",
  //       subItems: [
  //         {
  //           id: "createpwbasic",
  //           label: "Basic",
  //           link: "/auth-create-password-basic",
  //           parentId: "createpw",
  //         },
  //         {
  //           id: "createpwcover",
  //           label: "Cover",
  //           link: "/auth-create-password-cover",
  //           parentId: "createpw",
  //         },
  //         {
  //           id: "createpwboxed",
  //           label: "Boxed",
  //           link: "/auth-create-password-boxed",
  //           parentId: "createpw",
  //         },
  //         {
  //           id: "createpwmodern",
  //           label: "Modern",
  //           link: "/auth-create-password-modern",
  //           parentId: "createpw",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   id: "pages",
  //   label: "Pages",
  //   icon: <Codesandbox />,
  //   parentId: 2,
  //   subItems: [
  //     {
  //       id: "account",
  //       label: "Account",
  //       link: "/pages-account",
  //       parentId: "pages",
  //     },
  //     {
  //       id: "setting",
  //       label: "Settings",
  //       link: "/pages-account-settings",
  //       parentId: "pages",
  //     },
  //     {
  //       id: "pricing",
  //       label: "Pricing",
  //       link: "/pages-pricing",
  //       parentId: "pages",
  //     },
  //     {
  //       id: "faq",
  //       label: "FAQs",
  //       link: "/pages-faqs",
  //       parentId: "pages",
  //     },
  //     {
  //       id: "contactus",
  //       label: "Contact US",
  //       link: "/pages-contact-us",
  //       parentId: "pages",
  //     },
  //     {
  //       id: "comingsoon",
  //       label: "Coming Soon",
  //       link: "/pages-coming-soon",
  //       parentId: "pages",
  //     },
  //     {
  //       id: "errorpage",
  //       label: "Error Pages",
  //       parentId: "pages",
  //       subItems: [
  //         {
  //           id: "404",
  //           label: "404",
  //           link: "/pages-404",
  //           parentId: "errorpage",
  //         },
  //         {
  //           id: "offline",
  //           label: "Offline",
  //           link: "/pages-offline",
  //           parentId: "errorpage",
  //         },
  //       ],
  //     },
  //     {
  //       id: "maintenance",
  //       label: "Maintenance",
  //       link: "/pages-maintenance",
  //       parentId: "pages",
  //     },
  //   ],
  // },
];

export { menuData };
